
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import loading from '@/components/loading'
import btnGeneral from '@/components/common/buttons/btn-general'

export default {
  components: {
    btnGeneral,
    ValidationProvider,
    ValidationObserver,
    loading,
  },
  data() {
    return {
      isLoading: false,
      email: null,
      year: '',
      opened: false,
    }
  },
  computed: {
    footerData() {
      const layoutData = this.$store.state.layoutData?.content || {}
      return {
        pre_footer: layoutData.pre_footer || {},
        footer: layoutData.footer || {},
      }
    },
  },
  mounted() {
    this.getYear()
  },
  methods: {
    slickOpen() {
      this.opened = true
    },
    slickClose() {
      this.opened = false
    },
    showModalDialog(title, description, type) {
      this.$swal({
        icon: type,
        html:
          '<div class="dialog-container">' +
          '<span class="icon type_icon_' +
          type +
          '"></span>' +
          '<div class="content_dialog_general">' +
          '<span class="titleModal">' +
          title +
          '</span>' +
          '<span class="descriptionModal">' +
          description +
          '</span>' +
          '</div>' +
          '</div>',
        showCloseButton: true,

        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false,
      })
    },
    async onSubmit() {
      try {
        this.isLoading = true
        const success = await this.$refs.form.validate()

        if (!success) {
          return
        }
        const recaptchaResponse = await this.$recaptcha?.('footerNewsletter')
        await this.$store.dispatch('apis/sendNewsletter', {
          email: this.email,
          recaptchaResponse,
        })
        this.email = ''
        this.$refs.form.reset() // ✅ Resetea errores y estados tocados

        this.showModalDialog(
          this.$t('newsletter.title'),
          this.$t('newsletter.description'),
          'success'
        )
      } catch (e) {
        this.$showErrorModalDialog(e, this.$t('errorModal.server'))
      } finally {
        this.isLoading = false
      }
    },
    getYear() {
      const date = new Date()
      const year = date.getUTCFullYear()
      this.year = year
    },
    isExternalLink(url) {
      if (!url) return false

      // Si la URL comienza con '/' o no tiene protocolo, es interna
      if (url.startsWith('/') || !url.includes('://')) {
        return false
      }

      try {
        // Comprueba si el dominio es diferente al actual
        const urlHost = new URL(url).hostname
        return urlHost !== window.location.hostname
      } catch (e) {
        // Si hay un error al parsear la URL, asumimos que es interna
        return false
      }
    },
  },
}
